import { collection, doc } from "firebase/firestore";
import { db } from "@/lib/firebase-firestore";

export const paths = {
  discoveryModel: (customerId: string, modelId: string) => doc(db, "customers", customerId, "discoveryModels", modelId),
  discoveryModelHistory: (customerId: string, modelId: string) => doc(db, "customers", customerId, "discoveryModelHistory", modelId),
  discoveryLive: (customerId: string) => doc(db, "customers", customerId, "discoveryConfig", "live"),
  systemAdmin: (uid: string) => doc(db, "system", "admins", "users", uid),
  customer: (customerId: string) => doc(db, "customers", customerId),
  members: (customerId: string) => collection(db, "customers", customerId, "members"),
  member: (customerId: string, uid: string) => doc(db, "customers", customerId, "members", uid),
  business: (customerId: string) => doc(db, "customers", customerId, "business", "profile"),
  products: (customerId: string) => collection(db, "customers", customerId, "products"),
  product: (customerId: string, id: string) => doc(db, "customers", customerId, "products", id),
  services: (customerId: string) => collection(db, "customers", customerId, "services"),
  service: (customerId: string, id: string) => doc(db, "customers", customerId, "services", id),
  knowledge: (customerId: string) => collection(db, "customers", customerId, "knowledge"),
  knowledgeItem: (customerId: string, id: string) => doc(db, "customers", customerId, "knowledge", id),
  scenarios: (customerId: string) => collection(db, "customers", customerId, "scenarios"),
  scenario: (customerId: string, id: string) => doc(db, "customers", customerId, "scenarios", id),
  discoveries: (customerId: string) => collection(db, "customers", customerId, "discoveries"),
  discovery: (customerId: string, id: string) => doc(db, "customers", customerId, "discoveries", id),
  leadActivities: (customerId: string, leadId: string) => collection(db, "customers", customerId, "leads", leadId, "activities"),
  leadActivity: (customerId: string, leadId: string, id: string) => doc(db, "customers", customerId, "leads", leadId, "activities", id),
  leads: (customerId: string) => collection(db, "customers", customerId, "leads"),
  lead: (customerId: string, id: string) => doc(db, "customers", customerId, "leads", id),
  sources: (customerId: string) => collection(db, "customers", customerId, "sources"),
  source: (customerId: string, id: string) => doc(db, "customers", customerId, "sources", id),
  context: (customerId: string) => doc(db, "customers", customerId, "context", "main"),
  contextSnapshot: (customerId: string, contextId: string) => {
    if (!contextId || contextId === "main" || contextId.includes("/")) throw new Error("Invalid Context snapshot ID");
    return doc(db, "customers", customerId, "context", contextId);
  },
  logs: (customerId: string) => collection(db, "customers", customerId, "logs"),
  log: (customerId: string, id: string) => doc(db, "customers", customerId, "logs", id),
  errors: (customerId: string) => collection(db, "customers", customerId, "errors"),
  error: (customerId: string, id: string) => doc(db, "customers", customerId, "errors", id),
  slug: (slug: string) => doc(db, "discoverySlugs", slug),
};
